/* Gift guide A (gift-list) and B (gift-sets). The list lives in localStorage;
   the way back from the product page lives in sessionStorage 'charmlry.gp'
   and is read by snippets/gift-return.liquid. */
(function () {
  if (window.CharmlryGiftPlanner) return;
  window.CharmlryGiftPlanner = true;

  var RETURN_KEY = 'charmlry.gp';
  var LIST_KEY = 'charmlry.giftlist.v1';

  function store(key, val, session) {
    try { (session ? sessionStorage : localStorage).setItem(key, JSON.stringify(val)); } catch (e) { /* private mode */ }
  }
  function load(key, session) {
    try { return JSON.parse((session ? sessionStorage : localStorage).getItem(key) || 'null'); } catch (e) { return null; }
  }
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* Arrival date: today + the section's days, like the product page. */
  function fillArrival(root) {
    var days = +(root.getAttribute('data-gp-arrival-days') || 20);
    var dt = new Date(); dt.setHours(12, 0, 0, 0);
    dt = new Date(dt.getTime() + days * 864e5);
    var txt = dt.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    root.querySelectorAll('[data-gp-arrival]').forEach(function (el) { el.textContent = txt; });
  }

  /* Sets: remember the way back and the rest of the set before leaving. */
  function onGo(e) {
    var a = e.target.closest('[data-gp-go]');
    if (!a) return;
    var queue = (a.getAttribute('data-gp-queue') || '').split('||').filter(Boolean).map(function (q) {
      var i = q.indexOf('|');
      return i < 0 ? { url: q, label: '' } : { url: q.slice(0, i), label: q.slice(i + 1) };
    });
    store(RETURN_KEY, { back: location.pathname + location.search, backLabel: a.getAttribute('data-gp-back-label') || '', queue: queue }, true);
  }

  /* Sets on a phone: one card at a time, dots follow the scroll. */
  function initTrack(section) {
    var track = section.querySelector('[data-gp-track]');
    var dots = section.querySelector('[data-gp-dots]');
    if (!track || !dots) return;
    var spans = dots.children;
    var tick = null;
    track.addEventListener('scroll', function () {
      if (tick) return;
      tick = requestAnimationFrame(function () {
        tick = null;
        var cards = track.children, best = 0, bestD = Infinity, mid = track.scrollLeft + track.clientWidth / 2;
        for (var i = 0; i < cards.length; i++) {
          var d = Math.abs(cards[i].offsetLeft + cards[i].offsetWidth / 2 - mid);
          if (d < bestD) { bestD = d; best = i; }
        }
        for (var j = 0; j < spans.length; j++) spans[j].classList.toggle('is-on', j === best);
      });
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('.gp[data-gp-arrival-days]').forEach(fillArrival);
    document.querySelectorAll('.gp-sets').forEach(initTrack);
    document.addEventListener('click', onGo);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* ---------------- Gift list ---------------- */
  class GiftList extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var dataEl = this.querySelector('[data-gp-data]');
      try { this.data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      this.t = this.data.t || {};
      this.people = {};
      this.data.people.forEach((p) => { this.people[p.key] = p; });
      var saved = load(LIST_KEY);
      this.items = (saved && Array.isArray(saved.items) ? saved.items : []).filter((it) => this.people[it.key]);
      this.inCart = {};
      this.$items = this.querySelector('[data-gp-items]');
      this.$empty = this.querySelector('[data-gp-empty]');
      this.$bar = this.querySelector('[data-gp-bar]');
      this.$sum = this.querySelector('[data-gp-sum]');
      this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.data.currency || 'USD' });

      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('input', (e) => {
        var inp = e.target.closest('[data-gp-name]');
        if (!inp) return;
        var it = this.find(inp.closest('[data-id]').getAttribute('data-id'));
        if (it) { it.name = inp.value.slice(0, 30); this.save(); this.renderSummary(); }
      });
      // Coming back from a product page (also from the back-forward cache).
      window.addEventListener('pageshow', () => this.syncCart());
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.syncCart(); });

      if ('IntersectionObserver' in window && this.$sum) {
        this._sumVisible = false;
        new IntersectionObserver((en) => { this._sumVisible = en[0].isIntersecting; this.renderBar(); }, { threshold: 0.15 }).observe(this.$sum);
      }
      this.render();
      this.syncCart();
    }

    fmt(cents) {
      var s = this.money.format((cents || 0) / 100);
      return s.replace(/\.00$/, '');
    }
    find(id) { return this.items.find((it) => it.id === id); }
    save() { store(LIST_KEY, { items: this.items }); }
    product(it) { var p = this.people[it.key]; return p.products[Math.min(it.p || 0, p.products.length - 1)]; }
    who(it) { return it.name ? it.name : this.people[it.key].who; }

    add(key, p) {
      if (!this.people[key] || this.items.length >= (this.data.max || 12)) return null;
      var it = { id: Date.now().toString(36) + Math.random().toString(36).slice(2, 6), key: key, p: p || 0, name: '' };
      this.items.push(it);
      return it;
    }

    onClick(e) {
      var t = e.target;
      var add = t.closest('[data-gp-add]');
      if (add) {
        var it = this.add(add.getAttribute('data-gp-add'));
        this.save(); this.render();
        if (it) this.flash(it.id);
        return;
      }
      var starter = t.closest('[data-gp-starter]');
      if (starter) {
        var first = null;
        starter.getAttribute('data-gp-starter').split(',').forEach((raw) => {
          var parts = raw.trim().split(':');
          var n = this.add(parts[0].trim().toLowerCase(), Math.max(0, (+parts[1] || 1) - 1));
          if (n && !first) first = n;
        });
        this.save(); this.render();
        if (first) this.flash(first.id);
        return;
      }
      var alt = t.closest('[data-gp-alt]');
      if (alt) {
        var a = this.find(alt.closest('[data-id]').getAttribute('data-id'));
        if (a) { a.p = +alt.getAttribute('data-gp-alt'); this.save(); this.render(); }
        return;
      }
      var rm = t.closest('[data-gp-remove]');
      if (rm) {
        var id = rm.closest('[data-id]').getAttribute('data-id');
        this.items = this.items.filter((x) => x.id !== id);
        this.save(); this.render();
        return;
      }
      var go = t.closest('[data-gp-design], [data-gp-next], [data-gp-bar-next]');
      if (go && go.getAttribute('href') && go.getAttribute('href') !== '#') this.rememberReturn(go.getAttribute('data-item'));
    }

    /* The product page shows "Back to your gift list" and the next piece. */
    rememberReturn(id) {
      var todo = this.items.filter((it) => !this.inCart[it.id] && it.id !== id);
      store(RETURN_KEY, {
        back: location.pathname + location.search,
        backLabel: this.t.back || '',
        queue: todo.map((it) => ({ url: this.product(it).url + '?cfg_open=1', label: this.who(it) + ' · ' + this.product(it).label })),
      }, true);
    }

    flash(id) {
      var li = this.$items.querySelector('[data-id="' + id + '"]');
      if (!li) return;
      li.classList.add('is-new');
      setTimeout(() => li.classList.remove('is-new'), 900);
      var r = li.getBoundingClientRect();
      if (r.bottom > window.innerHeight - 90 || r.top < 0) li.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    /* Pieces already in the cart tick off the list, in list order per product.
       Satellites (birthstones, scratch cards) and add-ons don't count. */
    syncCart() {
      fetch((this.data.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          var count = {};
          (cart.items || []).forEach((li) => {
            var pr = li.properties || {};
            if (pr._parent || pr._card) return;
            count[li.handle] = (count[li.handle] || 0) + li.quantity;
          });
          var done = {};
          this.items.forEach((it) => {
            var h = this.product(it).handle;
            if (count[h] > 0) { done[it.id] = true; count[h] -= 1; }
          });
          this.inCart = done;
          this.cartCount = cart.item_count || 0;
          this.render();
        })
        .catch(() => { /* offline: keep the list as it is */ });
    }

    price(it, idx) {
      var p = this.product(it);
      return idx === 0 ? p.price : Math.min(p.price, this.data.extra || p.price);
    }

    render() {
      this.renderPeople();
      this.renderItems();
      this.renderSummary();
    }

    renderPeople() {
      var n = {};
      this.items.forEach((it) => { n[it.key] = (n[it.key] || 0) + 1; });
      this.querySelectorAll('[data-gp-add]').forEach((b) => {
        var c = n[b.getAttribute('data-gp-add')] || 0;
        var badge = b.querySelector('[data-gp-count]');
        b.classList.toggle('is-on', c > 0);
        if (badge) { badge.hidden = !c; badge.textContent = c; }
      });
    }

    renderItems() {
      this.$empty.hidden = this.items.length > 0;
      this.$items.innerHTML = this.items.map((it, idx) => {
        var person = this.people[it.key];
        var p = this.product(it);
        var done = !!this.inCart[it.id];
        var price = this.price(it, idx);
        var priceHtml = price < p.price
          ? '<s>' + this.fmt(p.price) + '</s> <b>' + this.fmt(price) + '</b>'
          : '<b>' + this.fmt(price) + '</b>' + (this.items.length > 1 ? ' <small>' + esc(this.t.first) + '</small>' : '');
        var alts = person.products.length > 1 && !done
          ? '<div class="gp-item__alts" role="radiogroup" aria-label="' + esc(person.who) + '">' + person.products.map((q, i) =>
            '<button type="button" class="gp-chip" role="radio" aria-checked="' + (i === (it.p || 0)) + '" data-gp-alt="' + i + '">' + esc(q.label) + '</button>').join('') + '</div>'
          : '';
        var hint = (it.p || 0) === 0 && person.hint ? '<span class="gp-item__hint">' + esc(person.hint) + '</span>' : '';
        var action = done
          ? '<span class="gp-item__done"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>' + esc(this.t.done) + '</span>'
          : '<a class="gp-btn gp-btn--sm" href="' + esc(p.url) + '?cfg_open=1" data-gp-design data-item="' + it.id + '">' + esc(this.t.design) + '</a>';
        return '<li class="gp-item' + (done ? ' is-done' : '') + '" data-id="' + it.id + '">' +
          '<div class="gp-item__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="120" height="120">' : '') + '</div>' +
          '<div class="gp-item__main">' +
            '<div class="gp-item__top"><span class="gp-item__who">' + esc(person.who) + '</span>' +
              '<button type="button" class="gp-item__x" data-gp-remove aria-label="' + esc(this.t.remove) + ' ' + esc(person.who) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
            '<input class="gp-item__name" type="text" maxlength="30" autocomplete="off" data-gp-name value="' + esc(it.name) + '" placeholder="' + esc(this.t.name) + '" aria-label="' + esc(this.t.name) + '">' +
            '<div class="gp-item__piece">' + esc(p.label) + hint + '</div>' +
          '</div>' +
          '<div class="gp-item__side"><div class="gp-item__price">' + priceHtml + '</div>' + action + '</div>' +
          alts +
        '</li>';
      }).join('');
    }

    renderSummary() {
      var rows = this.querySelector('[data-gp-sum-rows]');
      var total = 0, full = 0;
      rows.innerHTML = this.items.map((it, idx) => {
        var pr = this.price(it, idx);
        total += pr; full += this.product(it).price;
        return '<li><span>' + esc(this.who(it)) + ' · ' + esc(this.product(it).label) + (this.inCart[it.id] ? ' <i aria-label="' + esc(this.t.done) + '">✓</i>' : '') + '</span><b>' + this.fmt(pr) + '</b></li>';
      }).join('');
      var has = this.items.length > 0;
      this.querySelector('[data-gp-sum-empty]').hidden = has;
      this.querySelector('[data-gp-sum-total]').hidden = !has;
      this.querySelector('[data-gp-total]').textContent = this.fmt(total);
      var save = this.querySelector('[data-gp-save]');
      save.hidden = full - total <= 0;
      save.textContent = (this.t.save || '').replace('[amount]', this.fmt(full - total));

      var todo = this.items.find((it) => !this.inCart[it.id]);
      var next = this.querySelector('[data-gp-next]');
      var cart = this.querySelector('[data-gp-cart]');
      this._next = null;
      if (todo) {
        this._next = { href: this.product(todo).url + '?cfg_open=1', label: (this.t.next || '').replace('[who]', this.who(todo)), id: todo.id };
        next.href = this._next.href; next.textContent = this._next.label; next.setAttribute('data-item', todo.id); next.hidden = false;
        cart.hidden = !Object.keys(this.inCart).length && !this.cartCount;
        cart.className = 'gp-btn gp-btn--block gp-btn--ghost';
      } else if (has) {
        next.hidden = true;
        cart.hidden = false;
        cart.textContent = this.t.allDone || cart.textContent;
        cart.className = 'gp-btn gp-btn--block';
      } else {
        next.hidden = true;
        cart.hidden = true;
      }
      this._total = total;
      this.renderBar();
    }

    /* Phone: a bar at the bottom with the count, the total and the next step,
       while the summary is out of sight. */
    renderBar() {
      if (!this.$bar) return;
      var n = this.items.length;
      var show = n > 0 && !this._sumVisible;
      this.$bar.hidden = !show;
      document.documentElement.classList.toggle('gp-bar-on', show);
      if (!n) return;
      this.$bar.querySelector('[data-gp-bar-count]').textContent = n === 1 ? this.t.gifts1 : (this.t.giftsN || '').replace('[n]', n);
      this.$bar.querySelector('[data-gp-bar-total]').textContent = this.fmt(this._total);
      var b = this.$bar.querySelector('[data-gp-bar-next]');
      if (this._next) { b.href = this._next.href; b.textContent = this._next.label; b.setAttribute('data-item', this._next.id); }
      else { b.href = this.data.cartUrl || '/cart'; b.textContent = this.t.allDone; b.removeAttribute('data-item'); }
    }
  }
  if (!customElements.get('gift-list')) customElements.define('gift-list', GiftList);
})();
